import * as React from "react";
import FormattedNote from "./components/FormattedNote";
import UnformattedNote from "./components/UnformattedNote";

import Typography from "@mui/material/Typography";

const NotesCollectionBreakdown = ({ notesCollection }) => (
  <React.Fragment>
    {notesCollection.length > 0 ? (
      notesCollection.map(({ __typename, ...rest }, index) => (
        <div key={`note-${index}`}>
          {__typename === "FormattedNote" && <FormattedNote {...rest} />}
          {__typename === "UnformattedNote" && (
            <div style={{ marginBottom: "24px" }}>
              <UnformattedNote note={rest.note} />
            </div>
          )}
        </div>
      ))
    ) : (
      <Typography> N/A </Typography>
    )}
  </React.Fragment>
);

export default NotesCollectionBreakdown;
